// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2Dav4","label":"SetPasswdForm_label__mpQor"};